"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.widgets.disabled': 'Widgets feature is not available in your current plan.',
};
